import React, { useState } from "react";
import { Container, Form, Button, Card, Alert, InputGroup } from "react-bootstrap";
import { Eye, EyeOff } from "lucide-react";
import { Link } from "react-router-dom";
import authService from "../services/authService";
import { logger } from "../utils/logger";
const LoginComponent = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const result = await authService.login(email, password);
      setMessage(result.message);
      logger.info("Login attempt", { email, success: result.success, url: "/login" });
      setIsSuccess(result.success || false);
    } catch (error) {
      setMessage(error.message || "Login failed");
      setIsSuccess(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="row w-100 justify-content-center">
        <div className="col-12 col-md-6">
          <Card.Body>
            <div className="text-center mb-4">
              <img
                src="/images/plasticise-logo.png"
                alt="Company Logo"
                className="img-fluid mb-4"
                style={{ maxHeight: "150px", maxWidth: "150px" }}
              />
            </div>

            <h2 className="text-center mb-4 font-mynor-extra-bold">Plasticise</h2>

            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  autoComplete="username"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <InputGroup>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    autoComplete="current-password"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <Button 
                    variant="outline-secondary"
                    onClick={togglePasswordVisibility}
                    type="button"
                    className="d-flex align-items-center justify-content-center"
                    style={{ width: "48px" }}
                  >
                    {showPassword ? (
                      <EyeOff size={20} id="hidePassword" />
                    ) : (
                      <Eye size={20} id="showPassword" />
                    )}
                  </Button>
                </InputGroup>
              </Form.Group>

              <div className="d-flex gap-2 mt-3">
                <Button variant="primary" type="submit" className="w-100">
                  Log In
                </Button>


              </div>

              {message && (
                <Alert 
                  variant={isSuccess ? "success" : "danger"}
                  className="mt-3 text-center"
                  style={{
                    animation: "fadeIn 0.3s ease-in",
                    transition: "all 0.3s ease"
                  }}
                >
                  {message}
                </Alert>
              )}
            </Form>

            <div className="text-center mt-3">
              <a href="/reset-password" className="text-muted">
                Forgot Password?
              </a>
              <p className="small mt-3 mb-0">If you don’t have an account yet, <Link to="/start-trial">sign up here</Link>.</p>
            </div>
          </Card.Body>
        </div>
      </div>
    </Container>
  );
};

export default LoginComponent;